import React, { useCallback, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Graphics } from '@pixi/react';
import gsap from 'gsap';
import { boostedJackpotStore } from '../../../../store/boostedJackpotStore';
import { isMobile } from '../../../../core/helpers/isMobile';
import { soundService, SoundTypes } from '../../../../services/soundService';
import BoostedJackpotWheel from './boostedJackpotWheel/indxe';

let gsapWheelAnimation = null;
const BoostedJackpotWheelWrapper = observer(
  ({
    sectors = 6,
    cursor,
    wheelBtn,
    wheelValues,
    wheelBorder,
    containerConfigBoostedJackpotWheel,
  }) => {
    const wheelContainerRef = useRef(null);
    const { isWheel } = boostedJackpotStore;

    const handleWheelScaleDefault = useCallback((containerRef) => {
      if (gsapWheelAnimation) {
        gsapWheelAnimation.kill();
      }
      gsapWheelAnimation = gsap.to(containerRef.current.scale, {
        x: isMobile() ? 0.9 : 1,
        y: isMobile() ? 0.9 : 1,
        duration: 1,
      });
    }, []);

    useEffect(() => {
      if (wheelContainerRef.current && isWheel) {
        soundService.play(SoundTypes.OpenWheel);
        handleWheelScaleDefault(wheelContainerRef);
      }
    }, [wheelContainerRef, isWheel, handleWheelScaleDefault]);

    if (!isWheel) {
      return;
    }
    // eslint-disable-next-line consistent-return
    return (
      <>
        {!isMobile() && (
          <Graphics
            draw={(g) => {
              g.clear();
              g.alpha = 0.7;
              g.beginFill(0x030303);
              g.drawRect(0, 0, 1440, 860);
              g.interactive = true;
            }}
          />
        )}
        <Container {...containerConfigBoostedJackpotWheel} ref={wheelContainerRef} scale={0}>
          <BoostedJackpotWheel
            cursor={cursor}
            sectors={sectors}
            wheelBtn={wheelBtn}
            wheelBorder={wheelBorder}
            wheelValues={wheelValues}
            wheelContainerRef={wheelContainerRef}
            handleWheelScaleDefault={handleWheelScaleDefault}
            containerConfigBoostedJackpotWheel={containerConfigBoostedJackpotWheel}
          />
        </Container>
      </>
    );
  }
);

export default BoostedJackpotWheelWrapper;
